(function () {
  const icons = {
    home: '<path d="m3 10 9-7 9 7"/><path d="M5 9v12h14V9M9 21v-7h6v7"/>',
    exclusive: '<path d="M12 2 21 12 12 22 3 12Z"/><path d="M3 12h18M12 2l4 10-4 10-4-10Z"/>',
    coins: '<ellipse cx="12" cy="6" rx="8" ry="3"/><path d="M4 6v5c0 4 16 4 16 0V6M4 11v5c0 4 16 4 16 0v-5"/>',
    paint: '<path d="M12 3a9 9 0 1 0 0 18h2a2 2 0 0 0 1-4c-1-1-1-3 1-3h2a3 3 0 0 0 3-3c0-4-4-8-9-8Z"/><circle cx="7.5" cy="10" r="1"/><circle cx="11" cy="6.5" r="1"/><circle cx="16" cy="8" r="1"/>',
    tabletop: '<path d="m12 2 9 5-9 5-9-5 9-5Z"/><path d="M3 7v10l9 5 9-5V7M12 12v10"/>',
    dice: '<path d="m7 2 10 0 5 5v10l-5 5H7l-5-5V7Z"/><circle cx="8" cy="8" r="1"/><circle cx="16" cy="16" r="1"/><circle cx="12" cy="12" r="1"/>',
    collectibles: '<path d="M4 8h16l-1 13H5L4 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    lego: '<path d="M3 9h18v12H3zM7 9V5h4v4m2 0V5h4v4"/>',
    universe: '<circle cx="12" cy="12" r="5"/><ellipse cx="12" cy="12" rx="11" ry="4" transform="rotate(-25 12 12)"/>',
    care: '<circle cx="12" cy="12" r="10"/><path d="M9 9a3 3 0 1 1 5 2c-2 1-2 2-2 3m0 4h.01"/>',
    contact: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 7 9-7"/>',
    sword: '<path d="m14 4 6-2-2 6-9 9-4-4 9-9Z"/><path d="m5 13-3 3 6 6 3-3M12 6l6 6"/>',
    blood: '<path d="M12 2C9 7 5 11 5 15a7 7 0 0 0 14 0c0-4-4-8-7-13Z"/><path d="M9 16a3 3 0 0 0 3 3"/>',
    flame: '<path d="M12 22a7 7 0 0 0 7-7c0-4-3-6-4-11-2 3-3 5-3 7-2-1-3-3-3-4-1 3-4 6-4 9a7 7 0 0 0 7 6Z"/>',
    diablo: '<path d="M12 2 9 8l-5-3 2 8-3 3 7-1 2 7 2-7 7 1-3-3 2-8-5 3-3-6Z"/><path d="m9 8 3 4 3-4M8 13l4 3 4-3"/>',
    bat: '<path d="M2 5 8 8l4-3 4 3 6-3-2 8-5-2-3 5-3-5-5 2Z"/><path d="M12 13v8"/>',
    ring: '<ellipse cx="12" cy="12" rx="10" ry="5.5" transform="rotate(-25 12 12)"/><ellipse cx="12" cy="12" rx="6.8" ry="2.8" transform="rotate(-25 12 12)"/><path d="m5 9 2 1m2-3 1 2m3-3 1 2m3-1 1 2m1 2 2 1"/>',
    moon: '<path d="M20 15A8 8 0 0 1 9 4a8 8 0 1 0 11 11Z"/>',
    bug: '<path d="M8 8 5 5m11 3 3-3M5 12H2m20 0h-3M5 18l-3 2m17-2 3 2"/><rect x="6" y="6" width="12" height="16" rx="6"/><path d="M12 6v16M6 12h12"/>',
    ghost: '<path d="M5 21V11a7 7 0 0 1 14 0v10l-4-2-3 2-3-2-4 2Z"/><circle cx="9" cy="11" r="1"/><circle cx="15" cy="11" r="1"/>',
    shield: '<path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"/><path d="m9 12 2 2 4-4"/>',
    music: '<path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
    cards: '<rect x="5" y="3" width="12" height="17" rx="2"/><path d="M9 7h4M9 11h4M9 15h2"/><path d="M17 7h2v14H7v-1"/>',
    eye: '<path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>',
    brush: '<path d="m14 4 6 6-9 9-6-6 9-9Z"/><path d="m5 13-3 8 8-2M14 4l2-2 6 6-2 2"/>',
    spray: '<path d="M7 8h10l2 13H5L7 8Z"/><path d="M9 8V4h6v4M11 4V2h6M17 3h4"/>',
    mini: '<circle cx="12" cy="5" r="3"/><path d="M7 21v-5l2-5h6l2 5v5M9 12l-4 4m10-4 4 4M9 21v-5m6 5v-5"/>',
    tools: '<path d="m14 7 3-3 4 4-3 3"/><path d=\"m4 20 9-9M5 5a5 5 0 0 0 6 6l-6 9-3-3 9-6a5 5 0 0 0 6-6\"/>',
    gear: '<circle cx="12" cy="12" r="3"/><path d="m19 13 2 1-2 4-2-1-2 2v2H9v-2l-2-2-2 1-2-4 2-1v-3l-2-1 2-4 2 1 2-2V2h6v2l2 2 2-1 2 4-2 1v3Z"/>',
    gem: '<path d="M6 3h12l4 6-10 13L2 9l4-6Z"/><path d="M2 9h20M6 3l3 6 3 13 3-13 3-6"/>',
    cup: '<path d="M4 4h13v10a6 6 0 0 1-12 0V4Z"/><path d="M17 6h2a3 3 0 0 1 0 6h-2M3 22h16"/>',
    cube: '<path d="m12 2 9 5v10l-9 5-9-5V7l9-5Z"/><path d="m3 7 9 5 9-5M12 12v10"/>',
    key: '<circle cx="8" cy="9" r="5"/><path d="m12 12 9 9m-4-4 3-3m-6 0 3-3"/>',
    pin: '<path d="M12 22s7-7 7-13a7 7 0 0 0-14 0c0 6 7 13 7 13Z"/><circle cx="12" cy="9" r="2"/>',
    mug: '<path d="M4 5h13v11a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V5Z"/><path d="M17 8h2a3 3 0 0 1 0 6h-2M7 2v2m5-2v2"/>',
    sparkle: '<path d="m12 2 2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2L12 2Z"/>',
    bag: '<path d="M4 8h16l-1 13H5L4 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    print: '<rect x="3" y="3" width="18" height="18" rx="1"/><circle cx="8" cy="8" r="1"/><path d="m4 18 5-5 3 3 3-4 5 6"/>',
    bottle: '<path d="M9 3h6v4l2 2v12H7V9l2-2V3Z"/><path d="M9 7h6M7 13h10"/>',
    trophy: '<path d="M8 3h8v5a4 4 0 0 1-8 0V3Z"/><path d="M8 5H4v3a4 4 0 0 0 4 4m8-7h4v3a4 4 0 0 1-4 4M12 12v6m-5 3h10m-8-3h6"/>',
    house: '<path d="m3 10 9-7 9 7"/><path d="M5 9v12h14V9M9 21v-7h6v7"/>',
    building: '<path d="M3 21h18M5 21V5l7-3 7 3v16M9 8h2m2 0h2m-6 4h2m2 0h2m-6 4h2m2 0h2"/>',
    leaf: '<path d="M20 4C10 3 4 8 4 14a6 6 0 0 0 6 6c6 0 11-6 10-16Z"/><path d="M3 22 14 11"/>',
    rocket: '<path d="M12 22c-2-3-2-5-2-7l4-4c2 0 4 0 7-2-1 7-4 11-9 13Z"/><path d="m10 15-5 1-3 4 6 0m6-9-1-5 4-4 2 7"/><circle cx="16" cy="8" r="1"/>',
    castle: '<path d="M3 21V8l4 3V6l5 3 5-3v5l4-3v13Z"/><path d="M9 21v-5h6v5"/>',
    ninja: '<path d="M4 9a8 8 0 0 1 16 0v7H4V9Z"/><path d="M4 12h16M8 10h2m4 0h2"/>',
    crown: '<path d="m3 7 5 5 4-8 4 8 5-5-2 13H5L3 7Z"/>',
    wand: '<path d="m5 19 12-12M14 3v4m-2-2h4M20 12v4m-2-2h4M4 4v4M2 6h4"/>',
    bulb: '<path d="M9 18h6m-5 3h4M8 15a7 7 0 1 1 8 0c-1 1-1 2-1 3h-6c0-1 0-2-1-3Z"/>',
    car: '<path d="m4 16 2-7h12l2 7v4h-3v-2H7v2H4v-4Z"/><circle cx="7" cy="15" r="1"/><circle cx="17" cy="15" r="1"/>',
    star: '<path d="m12 2 3 7 7 1-5 5 1 7-6-4-6 4 1-7-5-5 7-1 3-7Z"/>',
    mushroom: '<path d="M3 11a9 7 0 0 1 18 0H3Z"/><path d="M10 11v6a3 3 0 0 0 6 0v-6M7 7h.01m5-2h.01m5 3h.01"/>',
    pickaxe: '<path d="m4 20 12-12m-9-4 13 1 3 5-8-2"/>',
    hero: '<path d="M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6l-8-3Z"/><path d="m8 12 2-2 2 2 2-2 2 2"/>',
    dinosaur: '<path d="M4 20v-5l3-4 1-5 4-2 4 3 3 1 2 4-3 2-2-2h-4l-2 3v5M8 6 6 3m8 4 1-3"/>',
    target: '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>',
    pirate: '<path d="M3 11a9 9 0 0 1 18 0l-3 2-6-2-6 2-3-2Z"/><path d="M5 13v4l7 4 7-4v-4M9 15h.01m6 0h.01"/>',
    book: '<path d="M3 4h7a3 3 0 0 1 3 3v14a3 3 0 0 0-3-3H3V4Z"/><path d="M21 4h-5a3 3 0 0 0-3 3v14a3 3 0 0 1 3-3h5V4Z"/>',
    lightning: '<path d="M13 2 4 14h7l-1 8 10-13h-7l0-7Z"/>',
    person: '<circle cx="12" cy="6" r="3"/><path d="M6 21v-4a6 6 0 0 1 12 0v4M9 13l3 3 3-3"/>',
    d20: '<path d="m12 2 8 5 2 9-10 6L2 16l2-9 8-5Z"/><path d="m4 7 8 5 8-5M2 16l10-4 10 4M12 2v10"/>'
  };
  const titleMap = {};
  const map = (key, titles) => titles.split('|').forEach(title => titleMap[title.toLowerCase()] = key);
  map('home', 'home');
  map('exclusive', 'geekybrushers exclusive');
  map('coins', 'custom made coins|coins, ingots & medallions|custom coins & tokens');
  map('paint', 'paints & brushes|speedpaints|art');
  map('spray', 'sprays');
  map('brush', 'warpaints fanatic|brushes');
  map('tabletop', 'tabletop & miniatures');
  map('mini', 'miniatures & figures|replicas & display collectibles|minifigures|bloodborne figures|hollow knight figures|league of legends figures|yu-gi-oh figures|silent hill figures');
  map('d20', 'tabletop games & expansions|dungeons & dragons|magic: the gathering|dungeons & lasers');
  map('tools', 'hobby supplies|shipping information|processing times|returns & refunds');
  map('dice', 'dice|all dice|dice blocks');
  map('gem', 'dice earrings|jewellery & wearables');
  map('cube', 'metal dice|polyhedral dice');
  map('cup', 'cup-o-dice');
  map('collectibles', 'collectibles & accessories');
  map('key', 'keychains');
  map('pin', 'pins');
  map('mug', 'desk mats & coasters');
  map('sparkle', 'stickers & decals');
  map('bag', 'bags & totes');
  map('print', 'signs & art prints');
  map('bottle', 'bottle openers & bar accessories');
  map('cards', 'cards & games|yu-gi-oh|yu-gi-oh!');
  map('house', 'home & lifestyle');
  map('lego', 'lego');
  map('building', 'architecture');
  map('leaf', 'botanicals');
  map('rocket', 'star wars™|star wars|metroid');
  map('gear', 'technic');
  map('castle', 'disney|harry potter™|harry potter');
  map('ninja', 'ninjago®|teenage mutant ninja turtles');
  map('crown', 'icons|iconic');
  map('wand', 'ideas');
  map('car', 'speed champions');
  map('star', 'super mario™|editions|pokémon|fortnite|avatar|thundercats|2000 ad');
  map('mushroom', 'minecraft');
  map('hero', 'marvel / super heroes|dc comics');
  map('dinosaur', 'jurassic world');
  map('target', 'target');
  map('pirate', 'one piece');
  map('book', 'editions');
  map('lightning', 'pokemon|pokémon');
  map('person', 'doom|fallout|the elder scrolls|resident evil|transformers|metal gear solid|starcraft|masters of the universe|spongebob squarepants|teenage mutant ninja turtles');
  map('sword', 'berserk');
  map('blood', 'bloodborne');
  map('flame', 'dark souls');
  map('diablo', 'diablo');
  map('bat', 'friday the 13th|it');
  map('moon', 'elden ring nightreign');
  map('ring', 'elden ring');
  map('ring', 'lord of the rings|the lord of the rings');
  map('bug', 'hollow knight');
  map('ghost', 'horror|scream|silent hill');
  map('shield', 'league of legends');
  map('music', 'music|iron maiden|disturbed');
  map('eye', 'lovecraft & cosmic horror|cthulhu & cosmic horror|cthulhu mythos');
  map('universe', 'shop by universe');
  map('care', 'customer care');
  map('contact', 'contact|contact us|faq');
  map('sparkle', 'halloween');
  map('rocket', 'thundercats');
  map('crown', 'icons');
  map('house', 'home');
  function normalizedTitle(text) {
    return text.replace(/^\s*(?:\p{Extended_Pictographic}|\p{Emoji_Presentation}|\uFE0F|\u200D|\p{Emoji_Modifier})+\s*/u, '').trim().toLowerCase().replace(/\s+/g, ' ');
  }
  function iconKey(label) {
    const text = label.textContent.trim();
    return titleMap[text.toLowerCase().replace(/\s+/g, ' ')] || titleMap[normalizedTitle(text)] || null;
  }
  function removeLeadingEmoji(label) {
    const node = Array.from(label.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
    if (node) node.textContent = node.textContent.replace(/^\s*(?:\p{Extended_Pictographic}|\p{Emoji_Presentation}|\uFE0F|\u200D|\p{Emoji_Modifier})+\s*/u, '');
  }
  function addIcon(label) {
    if (!(label instanceof HTMLElement) || label.querySelector(':scope > .gb-menu-icon')) return;
    const key = iconKey(label);
    if (!key || !icons[key]) return;
    removeLeadingEmoji(label);
    const icon = document.createElement('span');
    icon.className = 'gb-menu-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">' + icons[key] + '</svg>';
    label.prepend(icon);
  }
  function applyIcons() {
    document.querySelectorAll('.menu-drawer__menu-item-text, .menu-list__link-title, .mega-menu__link-title, .menu-list--mobile .menu-list__list > li > a').forEach(addIcon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyIcons);
  else applyIcons();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; applyIcons(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();